module.exports = __webpack_public_path__ + "static/media/new-why_choose.b3e08206.jpg";